import { IconType } from 'react-icons/lib';
import {MdHomeWork} from "react-icons/md";
import {FaCar, FaTools, FaUser} from "react-icons/fa";
import {AiFillPicture} from "react-icons/ai";

export interface Menu {
    title: string;
    path?: string;
    icon?: IconType;
    subMenus?: Menu[];
}

export default [
    {
        title: 'Home',
        path: '/',
        private: false
    },
    {
        title: 'Imóveis',
        path: '/imoveis',
        private: false
    },
    {
        title: 'Veículos',
        path: '/veiculos',
        private: false
    },
    {
        title: 'Equipamentos',
        path: '/equipamentos',
        private: false
    },
    {
        title: 'Imóveis',
        path: '/imoveis/lista',
        icon: MdHomeWork,
        private: true
    },
    {
        title: 'Veículos',
        path: '/veiculos/lista',
        icon: FaCar,
        private: true
    },
    {
        title: 'Equipamentos',
        path: '/equipamentos/lista',
        icon: FaTools,
        private: true
    },
    {
        title: 'Usuários',
        path: '/usuarios',
        icon: FaUser,
        private: true
    },
    {
        title: 'Banners',
        path: '/banners/lista',
        icon: AiFillPicture,
        private: true
    },
];